/**
 * Same-origin dual Admin PWAs: tenant (`/`, `/tenants`, …) vs Dev (`/dev*`).
 * Distinct manifest `id` + `start_url` so Chromium can install two apps.
 */

export type AdminPwaInstallSurface = 'tenant' | 'dev';

export const ADMIN_PWA_TENANT_MANIFEST_HREF = '/manifest.webmanifest';
export const ADMIN_PWA_DEV_MANIFEST_HREF = '/manifest-dev.webmanifest';

export const ADMIN_PWA_TENANT_ID = 'rpapp-admin-pwa';
export const ADMIN_PWA_DEV_ID = 'rpapp-dev-pwa';

export const ADMIN_PWA_TENANT_APPLE_TITLE = 'Admin';
export const ADMIN_PWA_DEV_APPLE_TITLE = 'Dev';

/** True for `/dev` and every `/dev/...` path (login, nested ops, etc.). */
export function isAdminDevPwaPath(pathname: string): boolean {
  if (pathname === '/dev') {
    return true;
  }
  return pathname.startsWith('/dev/');
}

/** @deprecated Use {@link isAdminDevPwaPath} — same `/dev*` check. */
export const isAdminPlatformPwaPath = isAdminDevPwaPath;

export function resolveAdminPwaInstallSurface(pathname: string): AdminPwaInstallSurface {
  return isAdminDevPwaPath(pathname) ? 'dev' : 'tenant';
}

export function resolveAdminPwaManifestHref(surface: AdminPwaInstallSurface): string {
  return surface === 'dev' ? ADMIN_PWA_DEV_MANIFEST_HREF : ADMIN_PWA_TENANT_MANIFEST_HREF;
}

export function resolveAdminPwaAppleTitle(surface: AdminPwaInstallSurface): string {
  return surface === 'dev' ? ADMIN_PWA_DEV_APPLE_TITLE : ADMIN_PWA_TENANT_APPLE_TITLE;
}
